import "./styles.css";
import Layout from "./layout/Layout";
export default function App() {
  return (
    <div className="App">
      <Layout />
    </div>
  );
}
